import { CorporateFormFields } from 'src/components/enterprise/features/Corporate/components/Form/types/CorporateForm';
import { CorpUIPayload } from 'src/types/Corp';
import { SSO_REDIRECT_URL_REGEX } from 'src/utilities/regexPatterns';

export type SSOFormFields = Pick<
  CorporateFormFields,
  | 'ssoEnabled'
  | 'ssoProviderId'
  | 'ssoUniqueIdentifier'
  | 'ssoRedirectEnabled'
  | 'ssoRedirectUrl'
>;

export type SSOUIPayload = Pick<
  CorpUIPayload,
  | 'ssoEnabled'
  | 'ssoUniqueIdentifier'
  | 'ssoProviderId'
  | 'ssoRedirectEnabled'
  | 'ssoRedirectUrl'
>;

const ssoDisabledPayload: SSOUIPayload = {
  ssoEnabled: false,
  ssoProviderId: '',
  ssoUniqueIdentifier: '',
  ssoRedirectEnabled: false,
  ssoRedirectUrl: null,
};

export const SSO_REDIRECT_URL_REQUIRED_MESSAGE =
  "Company's IdP url is required";
export const SSO_REDIRECT_URL_INVALID_MESSAGE =
  'Invalid url. It should start with https:// and have a valid IdP endpoint.';

export function isValidSsoRedirectUrl(value: string): boolean {
  return SSO_REDIRECT_URL_REGEX.test(value);
}

export function validateSsoRedirectUrl(value: string): boolean | string {
  return isValidSsoRedirectUrl(value) || SSO_REDIRECT_URL_INVALID_MESSAGE;
}

export function transformSSOUIToModel({
  ssoEnabled,
  ssoProviderId,
  ssoUniqueIdentifier,
  ssoRedirectEnabled,
  ssoRedirectUrl,
}: SSOFormFields): SSOUIPayload {
  if (!ssoEnabled) {
    return ssoDisabledPayload;
  }

  return {
    ssoEnabled,
    ssoProviderId,
    ssoUniqueIdentifier,
    ssoRedirectEnabled,
    ssoRedirectUrl:
      ssoRedirectEnabled && ssoRedirectUrl ? ssoRedirectUrl : null,
  };
}
